import { useLocalStorage } from "usehooks-ts";

import { LocalStorageKey } from "@/constants/shared";

export const useAuthenticatedLoadingState = () => {
  const [authenticatedLoadingState, setAuthenticatedLoadingState] =
    useLocalStorage(
      LocalStorageKey.UseAuthenticatedLoadingState +
        window.location.hostname +
        import.meta.env.MODE,
      false,
    );
  return {
    authenticatedLoadingState,
    setAuthenticatedLoadingState,
  };
};
